import { render, staticRenderFns } from "./AlbumSettingsWebhook.vue?vue&type=template&id=a8d0d820&"
import script from "./AlbumSettingsWebhook.vue?vue&type=script&lang=js&"
export * from "./AlbumSettingsWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports